<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ArenaEquipmentVersionList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEquipmentVersionList from '@/components/settings/arena/equipment-version/ArenaEquipmentVersionList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'Company',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ArenaEquipmentVersionList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addarenaequipmentversion' })
    }
  }
}
</script>
